import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  className = '',
  type = 'button',
  ...props
}) => {
  const baseClasses = `
    inline-flex items-center justify-center font-medium rounded-full 
    focus:outline-none focus:ring-2 focus:ring-offset-2 
    transition-colors duration-200
    disabled:opacity-50 disabled:cursor-not-allowed
  `;

  const variants = {
    primary: `
      bg-green-600 text-white 
      hover:bg-green-500 
      focus:ring-green-500 shadow-sm
    `,
    secondary: `
      bg-white text-gray-700 border border-gray-300 
      hover:bg-gray-50 
      focus:ring-gray-500 shadow-sm
    `,
    outline: `
      bg-transparent text-green-600 border border-green-600 
      hover:bg-green-50 hover:border-green-700 
      focus:ring-green-500
    `,
    danger: `
      bg-red-600 text-white 
      hover:bg-red-500 
      focus:ring-red-500 shadow-sm
    `,
    ghost: `
      bg-transparent text-gray-600 
      hover:bg-gray-100 
      focus:ring-gray-500
    `
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-4 text-lg'
  };

  const classes = `
    ${baseClasses}
    ${variants[variant] || variants.primary}
    ${sizes[size] || sizes.md}
    ${className}
  `;

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg 
          className="animate-spin -ml-1 mr-2 h-4 w-4" 
          fill="none" 
          viewBox="0 0 24 24"
        >
          <circle 
            className="opacity-25" 
            cx="12" 
            cy="12" 
            r="10" 
            stroke="currentColor" 
            strokeWidth="4"
          />
          <path 
            className="opacity-75" 
            fill="currentColor" 
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {children}
    </button>
  );
};

export default Button;
